<template>
  <div class="form-field-accordion">
    <div v-if="hasTitleSlot" class="form-field-accordion__title" @click="onToggle">
      <slot name="title"></slot>
    </div>
    <div v-if="!isOpened && !hasTitleSlot" class="form-field-accordion__title" @click="onToggle">
      <slot name="title_if_closed"></slot>
    </div>
    <div v-if="isOpened && !hasTitleSlot" class="form-field-accordion__title" @click="onToggle">
      <slot name="title_if_opened"></slot>
    </div>
    <div v-if="isOpened" class="form-field-accordion__body"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "M4FormFieldAccordion",
  data() {
    return {
      isOpened: this.open
    };
  },
  props: {
    title: {
      type: String,
      required: false
    },
    open: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    hasTitleSlot() {
      return typeof this.$slots.title === "function";
    }
  },
  methods: {
    onToggle() {
      this.isOpened = !this.isOpened;
    }
  }
};
</script>
